export default __webpack_public_path__ + "da7216adb72fa6d4e147fd4235fb7609.svg";